import { render, staticRenderFns } from "./CommunicationsEngagement.vue?vue&type=template&id=1058b57a&"
import script from "./CommunicationsEngagement.vue?vue&type=script&lang=js&"
export * from "./CommunicationsEngagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports